import React from "react";
import { Box, Typography } from "@mui/material";
import {
  approvalStatusColor,
  getApprovalStatusLabels,
  getTaskStatusLabels,
  MessageType,
  taskStatusColor,
} from "../../utils/constant";
import {
  colorSchemes,
  fontSizeSchemes,
  statusLabelStyleBox,
} from "../../assets/commonFunction";
import { useTranslation } from "react-i18next";

export default function TaskStatusButton({
  item,
  status,
  isCondition = "",
  buttonText = "",
  showTextStatus = true,
}) {
  const { t } = useTranslation();
  const appConstant = t("AppConstant", { returnObjects: true });
  const labels = status === "approval"?getApprovalStatusLabels(appConstant):getTaskStatusLabels(appConstant);
  const classes = {
    txt: {
      marginLeft: "2px !important;",
      color: colorSchemes.themeRedColor,
      fontSize: fontSizeSchemes.font12,
      fontWeight: 500,
    },
  };
  const statusKey = status === "approval" ? "approval_status" : "task_status";
  const statusColor = status === "approval" ? approvalStatusColor : taskStatusColor;
  const statusLabels = labels;
  const isConditionVal = isCondition !== "" ? isCondition : status === "approval" ? item?.type === MessageType?.Approval : item?.type === MessageType?.Task;
  const boxColor = "#000000";
  const boxBgColor = statusColor[item?.[statusKey]];
  const btnTxtStyle = {
    ...classes.txt,
    fontSize: {
      xs: "10px",
      sm: "11px",
      color: colorSchemes.black
    },
  };
  const btnText = buttonText !== "" ? buttonText : statusLabels[item?.[statusKey]];
  const appContent = t("AppContent", { returnObjects: true });

  return (
    <>
      {/* Pending Button */}
      {isConditionVal && (
        <Box>
          <Box
            display={"flex"}
            sx={statusLabelStyleBox}
            color={boxColor}
            bgcolor={boxBgColor}
          >
            {showTextStatus && (
              <Typography sx={btnTxtStyle}> {appContent?.KEY344}: </Typography>
            )}
            <Typography sx={btnTxtStyle}> {btnText}</Typography>
          </Box>
        </Box>
      )}
    </>
  );
}
